let _csrfToken = null;
let _csrfTokenPromise = null;

async function _fetchCsrfToken() {
  const res = await fetch('/api/csrf', { credentials: 'include' });
  if (!res.ok) {
    return null;
  }
  const body = await res.json().catch(() => null);
  const token = body && body.ok && body.csrfToken ? body.csrfToken : null;
  if (!token) {
    return null;
  }
  _csrfToken = token;
  return token;
}

function ensureCsrfToken() {
  if (_csrfToken) {
    return Promise.resolve(_csrfToken);
  }
  if (!_csrfTokenPromise) {
    _csrfTokenPromise = _fetchCsrfToken().finally(() => {
      _csrfTokenPromise = null;
    });
  }
  return _csrfTokenPromise;
}

export function resetCsrfToken() {
  _csrfToken = null;
  _csrfTokenPromise = null;
}

function isStateChangingMethod(method) {
  const m = String(method || 'GET').toUpperCase();
  return m === 'POST' || m === 'PUT' || m === 'PATCH' || m === 'DELETE';
}

function isSameOriginUrl(url) {
  if (typeof url !== 'string') return true;
  if (url.startsWith('/')) return true;
  try {
    const u = new URL(url, window.location.href);
    return u.origin === window.location.origin;
  } catch {
    return false;
  }
}

// Wraps `window.fetch` so state-changing same-origin requests automatically
// include the current CSRF token. Idempotent: calling more than once is a
// no-op after the first install.
let _installed = false;
export function installCsrfFetchInterceptor() {
  if (_installed) return;
  _installed = true;

  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const method = (init && init.method) || 'GET';
    const isWrite = isStateChangingMethod(method);
    const urlStr = typeof input === 'string' ? input : input && input.url;

    if (!isWrite || !isSameOriginUrl(urlStr)) {
      return nativeFetch(input, init);
    }

    const token = await ensureCsrfToken().catch(() => null);
    const headers = new Headers((init && init.headers) || undefined);
    if (token && !headers.has('X-CSRF-Token')) {
      headers.set('X-CSRF-Token', token);
    }
    return nativeFetch(input, { ...init, headers });
  };
}
